import { Collapse } from 'antd'
import { FunctionComponent, useState } from 'react'
import { PHPFAQQuestions } from './php-faq-constants'
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'
import Fade from 'react-reveal/Fade'
import useScreenWidth from '../../../common/hooks/use-screen-width'
import './php-faq.scss'


const { Panel } = Collapse

const FAQ: FunctionComponent = () => {
  const [activeIndex, setActiveIndex] = useState<string | string[]>('-1')
  const width = useScreenWidth()

  return (
    <div className="pt-8 md:pt-0 flex mx-auto justify-center bg-white w-full faq-section">
      <div className="php-faq-list flex flex-col w-full gap-8 max-w-screen-xl text-center justify-center items-center md:pt-8 pb-4 md:pb-8 px-8 md:px-12 xl:px-0 select-none">
        <Fade bottom>
          <div className="title text-[28px] md:text-[45px] font-[275] leading-10 md:leading-[67.5px] md:pt-8 pb-4">
            Frequently asked questions
          </div>
        </Fade>
        <Fade
          bottom
          fraction={width < 450 ? 0.01 : 0.1}
        >
          <Collapse
            ghost
            accordion={true}
            className="max-w-screen-lg w-full text-base md:text-2xl"
            expandIcon={({ isActive }) =>
              isActive ? <MinusCircleOutlined /> : <PlusCircleOutlined />
            }
            onChange={(key) => {
              setActiveIndex(key)
            }}
          >
            {PHPFAQQuestions.map((FAQ, index) => {
              return (
                <Panel
                  className={`trusana-faq-question-panel text-start py-1 rounded-3xl font-medium text-base md:text-[22px] !leading-[28px] ${
                    activeIndex === String(index)
                      ? 'gradient-border'
                      : 'border border-solid border-fossil my-3'
                  }`}
                  key={index}
                  header={FAQ.question}
                >
                  <div className="my-1 mx-7 md:mx-10 text-sm md:text-base !leading-[26px] font-normal whitespace-pre-line">
                    {FAQ.answer}
                  </div>
                </Panel>
              )
            })}
          </Collapse>
        </Fade>
      </div>
    </div>
  )
}

export default FAQ
